// extracted by mini-css-extract-plugin
export default {"dots":"styles_dots__ykOJm","dot":"styles_dot__XDJTT","purpleBg":"styles_purpleBg__z6f3B","orangeBg":"styles_orangeBg__ioMvU","greenBg":"styles_greenBg__kmvF5"};